export const globalScripts = () => {};
export const globalStyles = ":host{--klix-primary-color:#00bcd4}";
